import {STORE_CONTRACTOR_INSURANCE_REQUEST, STORE_CONTRACTOR_INSURANCE_SUCCESS, STORE_CONTRACTOR_INSURANCE_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_INSURANCE_REQUEST, UPDATE_CONTRACTOR_INSURANCE_SUCCESS, UPDATE_CONTRACTOR_INSURANCE_FAILURE} from '../actions';
import {
    INSURANCE_DOCUMENT_UPLOAD_REQUEST,
    INSURANCE_DOCUMENT_UPLOAD_SUCCESS,
    INSURANCE_DOCUMENT_UPLOAD_FAILURE,
    INSURANCE_DOCUMENT_DELETE_REQUEST,
    INSURANCE_DOCUMENT_DELETE_SUCCESS,
    INSURANCE_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_INSURANCE_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    name: '',
    liability: '',
    start_date: '',
    end_date: '',
    isUploading: false,
    isRemoving: false,
    uploadError: null,
    removeError: null,
    documents: []
};

const adminReducers = {
    [STORE_CONTRACTOR_INSURANCE_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_CONTRACTOR_INSURANCE_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null}
    },
    [STORE_CONTRACTOR_INSURANCE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_CONTRACTOR_INSURANCE_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_CONTRACTOR_INSURANCE_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null}
    },
    [UPDATE_CONTRACTOR_INSURANCE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [INSURANCE_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [INSURANCE_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isUploading: false, uploadError: null};
    },
    [INSURANCE_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [INSURANCE_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [INSURANCE_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);
        return {...state, documents, isRemoving: false, removeError: null}
    },
    [INSURANCE_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function admin(state = CONTRACTOR_INSURANCE_INITIAL_STATE, action) {
    let reducer = adminReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-insurance.js